import { render, staticRenderFns } from "./headimg.vue?vue&type=template&id=364ed024&scoped=true&"
import script from "./headimg.vue?vue&type=script&lang=js&"
export * from "./headimg.vue?vue&type=script&lang=js&"
import style0 from "./headimg.vue?vue&type=style&index=0&id=364ed024&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364ed024",
  null
  
)

export default component.exports